<template>
    <div class="scheme">
        <div class="mbx clearfix">
            <el-breadcrumb class="fl" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>顾问招募</el-breadcrumb-item>
                <el-breadcrumb-item>体验报名</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-table :data="tableData.list" border style="width: 100%">
            <el-table-column prop="name" label="姓名" width="100">
            </el-table-column>
            <el-table-column prop="mobile" label="电话" width="130">
            </el-table-column>
            <el-table-column prop="companyName" label="公司名称" width="300">
            </el-table-column>
            <el-table-column prop="emianl" label="邮箱" width="260">
            </el-table-column>
            <el-table-column prop="content" label="咨询内容" width="760">
            </el-table-column>
            <el-table-column :formatter="dateFormat" prop="createTime" label="提交时间" width="130">
            </el-table-column>
        </el-table>

        <div class="block">
            <el-pagination v-model="tableData" @current-change="handleCurrentChange" :current-page.sync="currentPage" layout="total, prev, pager, next, jumper" :total="tableData.total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
import { consulexGetPageList } from '../api/api.js'
import base from '../assets/js/util.js'
export default {
  name: 'experience',
  created () {
    this.getList()
  },
  data () {
    return {
      tableData: [],
      formLabelWidth: '100px',
	  currentPage: 1
    }
  },
  methods: {
    // 转换时间戳
    dateFormat (row, column) {
      let date = row[column.property]
      if (date == null || date == undefined) return ''
      return base.formatDate(date)
    },
    getList () {
      consulexGetPageList({pageNum: this.currentPage}).then((res) => {
        this.tableData = res.data.data
      })
    },
    // 分页
    handleCurrentChange (val) {
	  this.currentPage = val
	  this.getList()
    //   companyCase({ pageNum: val }).then((res) => {
    //     console.log(res)
    //     this.tableData = res.data.data
    //   })
    }
  }
}
</script>

<style scoped>
    .mbx {
        background-color: #f5f5f5;
        padding: 1% 4%;
    }

    .block {
        float: right
    }
</style>



// WEBPACK FOOTER //
// src/components/ht_experience.vue